.pinDetails {
  display: flex;
  padding: var(--spacing-16);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-08);
  align-self: stretch;
  height: 100px;
  background-color: var(--sparky-grey-100);
  animation: pop-in 1s;

  .pinDetail {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  @keyframes pop-in {
    0% {
      opacity: 0;
      transform: translateY(-216px);
      height: 0;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
      height: 100px;
    }
  }
}
